export const OTP_EXPIRY_SECONDS = 5 * 60;
export const OTP_CODE_LENGTH = 5;

export const getOtpExpiryTimestamp = (issuedAtMs = Date.now()) => {
  return issuedAtMs + OTP_EXPIRY_SECONDS * 1000;
};

export const getOtpSecondsRemaining = (expiresAt) => {
  if (!expiresAt) return 0;

  return Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
};

export const hasOtpExpired = (expiresAt) => {
  return !expiresAt || expiresAt <= Date.now();
};

export const formatOtpCountdown = (secondsRemaining) => {
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;

  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const sanitizeOtpValue = (value = "") => {
  return String(value)
    .replace(/\D/g, "")
    .slice(0, OTP_CODE_LENGTH);
};

export const isValidOtpFormat = (value = "") => {
  return sanitizeOtpValue(value).length === OTP_CODE_LENGTH;
};
